import { render, staticRenderFns } from "./ItemSup.vue?vue&type=template&id=1ddbc40f&scoped=true&"
import script from "./ItemSup.vue?vue&type=script&lang=js&"
export * from "./ItemSup.vue?vue&type=script&lang=js&"
import style0 from "./ItemSup.vue?vue&type=style&index=0&id=1ddbc40f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbc40f",
  null
  
)

export default component.exports